// extracted by mini-css-extract-plugin
export default {"mobile":"style_mobile__aYVcj","laptop":"style_laptop__AWxdY"};